import gql from 'graphql-tag';

// Design profiles of one account (spec 2026-10-13 step 2 part B), the default first.
export default gql`
  query getDesignProfiles($groupId: Int!) {
    design_profiles(where: { group_id: { _eq: $groupId } }, order_by: [{ is_default: desc }, { profile_id: asc }]) {
      profile_id
      name
      is_default
      headings
      text_on_image
      color_surfaces
      image_weight
      free_text
    }
  }
`;
